/** Supported marketplace locales — keep in sync across web + mobile. */
export const SUPPORTED_LOCALES = ['en', 'arz'];

/** Primary UX locale for Egypt; global default is English. */
export const DEFAULT_LOCALE = 'en';
export const EGYPT_PRIMARY_LOCALE = 'arz';

export const LOCALE_STORAGE_KEY = 'flea_locale';

export const LOCALE_META = {
  en: { labelKey: 'language.en', shortCode: 'EN', flag: '🇬🇧', dir: 'ltr', bcp47: 'en' },
  // Kept for legacy Accept-Language / stored-locale migration; not offered in UI.
  ar: { labelKey: 'language.ar', shortCode: 'AR', flag: '🇸🇦', dir: 'rtl', bcp47: 'ar' },
  arz: { labelKey: 'language.arz', shortCode: 'EG', flag: '🇪🇬', dir: 'rtl', bcp47: 'ar-EG' },
};

export function isRtlLocale(locale) {
  return LOCALE_META[locale]?.dir === 'rtl';
}

export function getAcceptLanguageHeader(locale) {
  const meta = LOCALE_META[locale];
  if (!meta) return 'en';
  if (locale === 'arz') return 'ar-EG, ar, en';
  if (locale === 'ar') return 'ar-EG, ar, en';
  return 'en';
}
